import React from 'react';
import { st, classes } from './Footer.st.css.js';
const Footer = ({ children, isSticky = false, }) => (React.createElement("div", { "data-hook": "modalMobileLayout-footer", "data-sticky-footer": isSticky, className: st(classes.root, {
        isSticky,
    }) }, children));
export default Footer;
//# sourceMappingURL=Footer.js.map